<div
  class="payment-detail gap-sm-2 alert alert-info has-icon alert-large text-start"
  role="alert"
>
  <div class="info-general d-flex flex-column">
    <div class="payment-info align-items-center d-flex gap-2" *ngIf="pacDetails?.depositDetailsInfo">
      <div class="mat-key">Deposit Category:</div>
      <div class="mat-value">{{ pacDetails?.depositDetailsInfo?.depositCategoryDisplayValue }}</div>
    </div>
    <div class="payment-info align-items-center d-flex gap-2" *ngIf="pacDetails?.depositDetailsInfo">
      <div class="mat-key">Deposit Type:</div>
      <div class="mat-value">{{ pacDetails?.depositDetailsInfo?.depositTypeDisplayName }}</div>
    </div>
    <div class="payment-info align-items-center d-flex gap-2" *ngIf="pacDetails?.depositDetailsInfo">
      <div class="mat-key">Case Number:</div>
      <div class="mat-value">{{ pacDetails?.depositDetailsInfo?.caseNumber || '--' }}</div>
    </div>
    <div class="payment-info align-items-center d-flex gap-2" *ngIf="pacDetails?.depositDetailsInfo">
      <div class="mat-key">Sub Case Number:</div>
      <div class="mat-value">{{ pacDetails?.depositDetailsInfo?.subCaseNumber || '--' }}</div>
    </div>
    <div class="payment-info align-items-center d-flex gap-2">
      <div class="mat-key">Payer ID:</div>
      <div class="mat-value">{{ pacDetails?.payerId || '--' }}</div>
    </div>
    <div class="payment-info align-items-center d-flex gap-2">
      <div class="mat-key">Payer Name:</div>
      <div class="mat-value">{{ pacDetails?.payerName || '--' }}</div>
    </div>
    <div class="payment-info align-items-center d-flex gap-2">
      <div class="mat-key">Email ID :</div>
      <div class="mat-value">{{ pacDetails?.emailId || '--' }}</div>
    </div>
    <div class="payment-info align-items-center d-flex gap-2">
      <div class="mat-key">Contact Number:</div>
      <div class="mat-value">{{ pacDetails?.contactNumber || '--' }}</div>
    </div>
    <div class="payment-info align-items-center d-flex gap-2">
      <div class="mat-key">Total Amount Payable:</div>
      <div class="mat-value">{{ showAmountFormatted(pacDetails?.totalAmountPayable) }}</div>
    </div>

    <div class="payment-info d-flex gap-2 align-items-center remarks" *ngIf="pacDetails?.depositDetailsInfo?.remarks">
      <div class="mat-key">Remarks:</div>
      <div class="mat-value">{{ pacDetails?.depositDetailsInfo?.remarks }}</div>
    </div>
  </div>
</div>
